/** Strings em falta no en-US.json do CDN EmulatorJS — evita spam na consola. */
export const EMULATOR_LANG_EXTRA = {
  "Are you sure you want to exit?": "Are you sure you want to exit?",
  "BUTTON 1": "BUTTON 1",
  "Cancel": "Cancel",
  "Create a room": "Create a room",
  "D-PAD DOWN": "D-PAD DOWN",
  "D-PAD LEFT": "D-PAD LEFT",
  "D-PAD RIGHT": "D-PAD RIGHT",
  "D-PAD UP": "D-PAD UP",
  "Decompress Game Assets": "Decompress Game Assets",
  "Direct Keyboard Input": "Direct Keyboard Input",
  "Downward Movement": "Downward Movement",
  "EJECT/INSERT DISK": "EJECT/INSERT DISK",
  "Error downloading core": "Error downloading core",
  "Error downloading game state": "Error downloading game state",
  "Error loading EmulatorJS runtime": "Error loading EmulatorJS runtime",
  "Exit": "Exit",
  "Exit Emulation": "Exit Emulation",
  "FAILED TO SAVE STATE": "FAILED TO SAVE STATE",
  "Forward Alt key": "Forward Alt key",
  "Fullscreen": "Fullscreen",
  "I": "I",
  "II": "II",
  "III": "III",
  "IV": "IV",
  "LEFT BUTTON": "LEFT BUTTON",
  "LEFT DIFFICULTY": "LEFT DIFFICULTY",
  "Core": "Core",
  "Rewind Enabled": "Rewind Enabled",
  "RetroArch Options": "RetroArch Options",
  "Core (Requires restart)": "Core (Requires restart)",
  "RetroArch Options (Requires restart)": "RetroArch Options (Requires restart)",
  "Rewind Enabled (Requires restart)": "Rewind Enabled (Requires restart)",
  "WebGL2 (Requires restart)": "WebGL2 (Requires restart)",
  "LEFT_TOP_SHOULDER": "L1",
  "RIGHT_TOP_SHOULDER": "R1",
  "LEFT_BOTTOM_SHOULDER": "L2",
  "LEFT_STICK": "Left Stick",
  "Lock Mouse": "Lock Mouse",
  "MODE1": "MODE1",
  "MODE2": "MODE2",
  "Menubar Mouse Trigger": "Menubar Mouse Trigger",
  "Microphone": "Microphone",
  "Movement Anywhere": "Movement Anywhere",
  "Outdated EmulatorJS version": "Outdated EmulatorJS version",
  "P": "P",
  "Play/Pause": "Play/Pause",
  "RIGHT BUTTON": "RIGHT BUTTON",
  "RIGHT DIFFICULTY": "RIGHT DIFFICULTY",
  "RIGHT_BOTTOM_SHOULDER": "R2",
  "RIGHT_STICK": "Right Stick",
  "RUN": "RUN",
  "SWAP DISKS": "SWAP DISKS",
  "Screen Recording Audio Bitrate": "Screen Recording Audio Bitrate",
  "Screen Recording FPS": "Screen Recording FPS",
  "Screen Recording Format": "Screen Recording Format",
  "Screen Recording Upscale": "Screen Recording Upscale",
  "Screen Recording Video Bitrate": "Screen Recording Video Bitrate",
  "Screenshot Format": "Screenshot Format",
  "Screenshot Source": "Screenshot Source",
  "Screenshot Upscale": "Screenshot Upscale",
  "Threads": "Threads",
  "V": "V",
  "VI": "VI",
  "X DOWN": "X DOWN",
  "X LEFT": "X LEFT",
  "X RIGHT": "X RIGHT",
  "X UP": "X UP",
  "Y DOWN": "Y DOWN",
  "Y LEFT": "Y LEFT",
  "Y RIGHT": "Y RIGHT",
  "Y UP": "Y UP",
  "□": "□",
  "△": "△",
  "○": "○",
  "ｘ": "ｘ"
};
